/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const generateInvoiceReportGql = gql`
  mutation generateInvoiceReports($input: GenerateInvoiceReportsInput!) {
    generateInvoiceReports(input: $input)
  }
`;
